import { observer } from "mobx-react"
import { RichContentView } from "@ui"

interface FaqDetailsProps {
  data: {
    id: string
    slug: string
    title: string
    text: string
  }
  id: string
}

export const LegalSectionView = observer(function FaqDetails(
  props: FaqDetailsProps,
) {
  const { data, id } = props

  return (
    <>
      <article id={id} className="relative space-y-5 tablet:space-y-6">
        {data.slug && (
          <div
            className="absolute top-[-80px] tablet:top-[-24px]"
            data-faq-id={data.slug}
          />
        )}
        <RichContentView src={data.text} />
      </article>
    </>
  )
})
